import { Injectable } from '@angular/core';
import { ToastItem } from '@inscomponents/core';
import { ToastDelay } from '@skylab-shared/ui';
import { injectToast } from '../popover/inject-toast';
import { toastItemToConfig } from './toast-item.adapter';

@Injectable({providedIn: 'root'})
export class ToastService {
    readonly #toast = injectToast();

    public async showAsync(options: ToastItem = {}) {
        const config = toastItemToConfig(options);

        config.duration ??= ToastDelay.Regular;

        const toast = await this.#toast.open(config);

        return () => Promise.resolve(toast.close());
    }
}
